import {
  completeCheckoutSession,
  createAppStoreTransaction,
  createAutoTopUpSetup,
  createBillingPortalSession,
  createCheckoutSession,
  deleteAutoTopUp,
  deleteSavedPaymentMethod,
  getAppStoreAccount,
  getSubscription,
  getTopUpSettings,
  listOffers,
  payWithSavedPaymentMethod,
  quoteSavedPaymentMethod,
  setAutoTopUp,
} from "./endpoints";

export { service } from "./endpoints";
export {
  autoTopUpThresholdExceedsPackMessage,
  cancellationWaivers,
  enterThresholdMessage,
  type WaivedPurchase,
} from "./messages";
export {
  AppStoreAccount,
  AppStoreAccountQuery,
  AppStoreEnvironment,
  AppStoreTransactionBody,
  AppStoreTransactionOutcome,
  AutoThresholdRaw,
  AutoTopUpRule,
  AutoTopUpSetupBody,
  AutoTopUpSetupResponse,
  BillingPortalSessionResponse,
  CheckoutCompletion,
  CheckoutOpener,
  CheckoutSessionId,
  CheckoutSessionResponse,
  CreateCheckoutSessionBody,
  IOS_APP_CHECKOUT_RETURN_PATH,
  ListOffersResponse,
  LiveSubscription,
  MAX_AUTO_THRESHOLD_CREDITS,
  Offer,
  OfferId,
  OPEN_CREDITS_PARAM,
  PackOffer,
  PackOfferId,
  QuotedPrice,
  SavedPaymentMethod,
  SavedPaymentMethodPaymentBody,
  SavedPaymentMethodPaymentResponse,
  SavedPaymentMethodQuote,
  SavedPaymentMethodQuoteBody,
  SubscriptionProvider,
  SubscriptionResponse,
  TopUpSettings,
} from "./schemas";

export const contract = {
  offers: { list: listOffers },
  checkoutSessions: { create: createCheckoutSession, complete: completeCheckoutSession },
  billingPortalSessions: { create: createBillingPortalSession },
  subscription: { get: getSubscription },
  topUpSettings: { get: getTopUpSettings },
  autoTopUp: { set: setAutoTopUp, delete: deleteAutoTopUp },
  autoTopUpSetups: { create: createAutoTopUpSetup },
  savedPaymentMethod: {
    delete: deleteSavedPaymentMethod,
    quote: quoteSavedPaymentMethod,
    pay: payWithSavedPaymentMethod,
  },
  appStoreAccount: { get: getAppStoreAccount },
  appStoreTransactions: { create: createAppStoreTransaction },
} as const;
